module.exports = __webpack_public_path__ + "static/media/NetBanking.66d520bc.svg";